import React from 'react';
import { STYLES } from '../../designSystem';

export default function PageContainer({ children, style }) {
  return (
    <div style={{ ...STYLES.pageContainer, ...style }}>
      {children}
    </div>
  );
}
